<template>
  <Modal title="解锁卡片" v-model="isShow" width="400" :closable="false"
         @on-ok="conformOk"
         @on-cancel="cancel">
    <p>
      确定要解除此人的会员卡锁定吗？</p>
  </Modal>
</template>
<script>
import { unlock } from '@/api/user'
export default {
  name: 'modalLock',
  data () {
    return {
      isShow: false,
      card_id: 0
    }
  },
  created () {
  },
  methods: {
    conformOk () {
      unlock(this.card_id).then(res => {
        this.$Message.success(res.msg)
        this.$emit('closeModal', true)
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    cancel () {
      this.$emit('closeModal', true)
    }

  }
}
</script>
